import { now } from "../../../messages/timing";
class Timer {
    constructor(timeIntervalInMilliseconds, time, callback, repeat = true) {
        this.callback = callback;
        this.repeat = repeat;
        this.timeIntervalInMilliseconds = 100;
        this.timeOfLastReset = 0;
        this.timeIntervalInMilliseconds = timeIntervalInMilliseconds;
        this.timeOfLastReset = time;
    }
    reset(time) {
        this.timeOfLastReset = time;
    }
    /**
     * Careful: Will reset the timer once it returned True.
     */
    isTimeUp(time) {
        const isTimeUp = (time - this.timeOfLastReset) >= this.timeIntervalInMilliseconds;
        if (isTimeUp) {
            this.timeOfLastReset = time;
        }
        return isTimeUp;
    }
    update(time) {
        var _a;
        if (!this.isTimeUp(time))
            return false;
        (_a = this.callback) === null || _a === void 0 ? void 0 : _a.call(this);
        return !this.repeat;
    }
}
export class ScriptTime {
    static get deltaTime() {
        return this._deltaTime;
    }
    static get time() {
        return now();
    }
    static setTimer(name, interval, callback, repeat = true) {
        this._activeTimers.set(name, new Timer(interval, this.time, callback, repeat));
    }
    static resetTimer(name) {
        var _a;
        (_a = this._activeTimers.get(name)) === null || _a === void 0 ? void 0 : _a.reset(this.time);
    }
    static isTimerUp(name) {
        var _a, _b;
        return (_b = (_a = this._activeTimers.get(name)) === null || _a === void 0 ? void 0 : _a.isTimeUp(this.time)) !== null && _b !== void 0 ? _b : false;
    }
    static clearTimer(name) {
        this._activeTimers.delete(name);
    }
    static _update() {
        const time = this.time;
        for (const [name, timer] of this._activeTimers) {
            if (!timer.update(time))
                continue;
            if (this._activeTimers.get(name) === timer) {
                this._activeTimers.delete(name);
            }
        }
    }
    static setInterval(fn, time) {
        return setInterval(fn, time);
    }
    static setTimeout(fn, time) {
        return setTimeout(fn, time);
    }
}
ScriptTime._deltaTime = 0;
ScriptTime._activeTimers = new Map();
